import styled from 'styled-components';

export const FollowUpsTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const AddFupButton = styled.button`
  cursor: pointer;
  width: 20px;
  height: 20px;
  background: #465eb6;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    color: #fff;
  }

  &:hover {
    background: #031795;
  }
`;

export const FollowUpsContent = styled.div`
  max-height: 600px;
  overflow-y: auto;
  padding-right: 8px;

  ::-webkit-scrollbar {
    display: none;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    display: none;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    display: none;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    background: #808080;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }

  ::-webkit-scrollbar-thumb:window-inactive {
    display: none;
    background: #808080;
  }

  :hover {
  ::-webkit-scrollbar {
    display: block;
  }
  ::-webkit-scrollbar-track {
    display: block;
  }
  ::-webkit-scrollbar-thumb {
    display: block;
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    display: block;
  }
    scrollbar-width: 2px;
    scrollbar-color: #465eb6;
  }
`;

export const FollowUpContainer = styled.div`
  border-bottom: 1px solid #0000001f;
  border-radius: 8px;

  cursor: pointer;
  
  display: flex;
  flex-direction: column;
  
  padding: 8px;
  margin-bottom: 6px;
  word-break: break-word;
  width: 100%;

  transition: all 0.2s;

  :hover {
    background: #0000001f;
  }
`;

export const FollowIndexRow = styled.div`
`;

export const FollowUpDateText = styled.span`
`;

export const FollowUpUserNameText = styled.span`
  color: #0000008c;
  font-weight: bold;
  font-size: 16px;
`;

export const FollowUpCommentText = styled.span`
  color: #0000008c; 
  margin-top: 16px;
  font-size: 16px;
`;

export const ReprogrammingInfo = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;  

  font-weight: bold;
  color: #0000008c;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex: 1;

  align-items: flex-end;
  justify-content: flex-end;

  margin-top: 26px;

  button + button {
    margin-left: 12px;
  }
`;
